export const getSsoCodeFromSearch = (search: string): string | null => {
   const params = new URLSearchParams(search)
   const code = params.get('ssoCode')
   return code && code.length > 0 ? code : null
}

export const stripSsoCodeFromUrl = (): void => {
   const params = new URLSearchParams(window.location.search)
   params.delete('ssoCode')
   const remaining = params.toString()
   const newUrl = remaining
      ? `${window.location.pathname}?${remaining}`
      : window.location.pathname
   window.history.replaceState(null, '', newUrl)
}
